module.exports = __webpack_public_path__ + "assets/img/title.cddd7438.png";